<template>
	<div class="mainMenu">
		<div
			v-for="(menu, menu_idx) in headerStore.getCountry === 'USA'
				? mainMenuListUSA
				: headerStore.getCountry === 'JPN'
					? mainMenuListJPN
					: mainMenuListKR"
			:key="menu_idx"
			class="menu"
		>
			<router-link :to="menu.path" class="menu_title" :class="{ on: $route.name === menu.group }">
				{{ menu.title }}
			</router-link>
		</div>
	</div>
</template>

<script setup lang="ts">
// constant
import { mainMenuListJPN, mainMenuListKR, mainMenuListUSA } from '@/constants/menu';
// store
import { useHeaderStore } from '@/stores/header';
const headerStore = useHeaderStore();
</script>

<style lang="scss" scoped>
.mainMenu {
	user-select: none;
	display: flex;
	gap: var(--space-xx-large);

	.menu {
		text-align: center;
		.menu_title {
			display: flex;
			align-items: center;
			justify-content: center;
			height: var(--header-height);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-large);
			cursor: pointer;
			&.on {
				color: var(--color-primary);
				border-bottom: 2.8px solid var(--color-primary);
			}
		}
	}
}
</style>
